CANDYRACK_DOCUMENT_LISTENER = false;

CANDYRACK_CUSTOM_BUTTON_SELECTORS = [".rmq-72475659, .btn, .btn--full, .add-to-cart, button#corner-sticky-atc-cta-button "];


/*CANDYRACK_VARIANT_SELECTOR_FUNCTION = (atcBtn) => {
  const container = atcBtn.closest(".rmq-72475659")
  const form = container.querySelector('product-form form')
  console.log(form)
  const productId = form.querySelector("input[data-productid]")._valueTracker.getValue()
  return Number(productId)
}


//DM
const dg_CONFIG = {
    price_selectors: '.Product-Price span, .Offer-Price span, .Offer-Price-Before-Discount span',
    add_to_cart_buttons: 'button.btn.btn--full.add-to-cart',
    applyattempsts: [200, 400, 600, 1500, 2000]
}
let candyRackIframeDocument;
function changingPrices() {
    let currentCurrency = document.querySelector('.product-block.product-block--price span.money').getAttribute('doubly-currency')
    if (currentCurrency) {
        const elementsPrice = candyRackIframeDocument.document.querySelectorAll(dg_CONFIG.price_selectors)
        if (currentCurrency.toLocaleLowerCase() != 'usd') {
            elementsPrice.forEach((elementPrice) => {
                if (!elementPrice.classList.contains('priceAplied')) {
                    const priceText = elementPrice.innerText
                    const dotIndex = priceText.length - priceText.indexOf('.') - 3
                    const finalPrice = priceText.substring(0, (priceText.length - dotIndex - 2)) + "99" + priceText.substring(priceText.length - dotIndex)
                    elementPrice.innerText = finalPrice
                    elementPrice.classList.add('priceAplied')
                }
            });
        }
    }
}
function initChanges() {
    try {
        candyRackIframeDocument = document.querySelector('iframe#candyrack-frame').contentWindow
    } catch (error) { }
    if (candyRackIframeDocument) {
        changingPrices()
        candyRackIframeDocument.addEventListener('click', (e) => {
            if (e.target.matches('.Offer-Description, .Offer-Description *')) {
                dg_CONFIG.applyattempsts.forEach((attemps) => {
                    setTimeout(() => {
                        changingPrices()
                    }, attemps);
                })
            }
        })
    }
}
window.addEventListener('mouseup', (e) => {
    if (e.target.matches(dg_CONFIG.add_to_cart_buttons)) {
        dg_CONFIG.applyattempsts.forEach((attemps) => {
            setTimeout(() => {
                initChanges()
            }, attemps);
        })
    }
})*/




